export const PromptPassword = {
  "Title": "Password",
  "Desc": "\"{fileName}\" is protected. A password is needed to access this document.",
  "EnterPassword": "Enter password:",
  "ErrorInvalid": "Invalid password. Please input again.",
  "ErrorPermission": "You don't have sufficient permissions to access the document."
}